// extracted by mini-css-extract-plugin
export default {"notice":"RefusedNotice_notice__27duQ"};